import React, { useRef, useState } from 'react'
import { Modal } from './Modal'
import { Divide, Upload } from 'lucide-react'
import { Api } from '../Service/api'
import MatchFollowingEquation, { DifferenceAnswer } from '../Component/ManuallyGenerate/MatchFollowingEquation'
import LatexTextRendererMcq from '../helper/Mathmcq'
import McqFormation from '../Component/ManuallyGenerate/McqFormation'
import { Divider } from '@mui/material'
import { ErrorToast, SuccessToast } from './Toast'
import { getlocalStorage } from '../Service/api/configuration/localstorage'
import { useDispatch } from 'react-redux'
import { ACTIONS } from '../redux/actions'

const QuestionReportModel = ({
    isModelOpen,
    setIsPurchaseModelOpen,
    queReportData,
}) => {
    const fileInputRef = useRef(null);
    const dispatch = useDispatch();
    const userData = getlocalStorage("userData");
    const [mistakeType, setMistakeType] = useState('Question')
    const [image, setImage] = useState(null)
    const [description, setDescription] = useState('')


    const handleImageRemove = (event) => {
        event.stopPropagation();
        setImage(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = ""; // Reset file input to allow the same file to be uploaded again
        }
    }
    const handleImageUploadClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append("image", file);
        const { data } = await Api.uplodedImage(formData)
        const result = JSON.parse(data);
        if (result) {
            setImage(result?.data);
        };
    }

    const handleSubmit = (event) => {
        event.preventDefault()
    }

    const handleModelClose = () => {
        setMistakeType('Question')
        setDescription('')
        setImage(null)
        setIsPurchaseModelOpen(false)
    }

    const handleModelApply = async () => {
        dispatch(ACTIONS.startLoading())
        try {
            let body = {
                user_id: userData?.user_id,
                questionId: queReportData?.id,
                type: mistakeType,
                description: description,
                image: image,
                semester: queReportData?.semester,
                standard: queReportData?.standard,
                subject: queReportData?.subject,
            }
            const { data } = await Api.QuestionsReport(JSON.stringify(body))
            const res = JSON.parse(data);
            if (res?.status === 200) {
                SuccessToast(res?.message);
                setIsPurchaseModelOpen(false)
            }
        } catch (e) {
            ErrorToast(e);
        } finally {
            dispatch(ACTIONS.stopLoading())
        }
    }
    let question = "queReportData"
    const answer = "queReportData"
    return (
        <div>
            <Modal
                title="Report Question"
                buttonText="Submit"
                width="max-w-2xl"
                disabled={false}
                modalOpen={isModelOpen}
                onApply={handleModelApply}
                onClose={handleModelClose}
            >
                <div style={{ maxHeight: "450px", overflow: "auto" }}>
                    <div className="mb-6 text-sm font-semibold py-3">
                        <div className=" mb-2 flex gap-2 ">
                            <div>Q.</div>
                            <div>
                                {queReportData?.m_equation != 1 ?
                                    // **********************without m_equation*************************
                                    (
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '-webkit-fill-available', overflow: 'auto' }}>
                                            <div style={{ fontWeight: '600' }}
                                                dangerouslySetInnerHTML={{
                                                    __html: queReportData?.finalquestion,
                                                }}
                                                className="table-container"
                                            />

                                            {(queReportData?.option1_img || queReportData?.option2_img || queReportData?.option3_img || queReportData?.option4_img || queReportData?.finaloption1 || queReportData?.finaloption2 || queReportData?.finaloption3 || queReportData?.finaloption4) && <McqFormation question={queReportData} />}

                                            {(queReportData?.qtype != "12" && queReportData?.perfact_metch?.length > 0) &&
                                                <MatchFollowingEquation data={queReportData} />
                                            }
                                        </div>
                                    ) : (
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '-webkit-fill-available', overflow: 'auto' }}>
                                            {/* *****************************with m_equation********************************** */}
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: queReportData?.finalquestion,
                                                }}
                                                style={{ width: "-webkit-fill-available" }}
                                                className="table-container"
                                            />

                                            <LatexTextRendererMcq
                                                text={queReportData}
                                            />

                                            {/* match the following */}
                                            {(queReportData?.qtype != "12" && queReportData?.perfact_metch?.length > 0) &&
                                                <MatchFollowingEquation data={queReportData} />
                                            }
                                        </div>

                                    )}
                            </div>
                        </div>
                        <div className="text-[#108EE3] flex gap-2 ">
                            <div>Ans.</div>
                            <div>
                                {queReportData?.m_equation != 1 ?
                                    // **********************without m_equation*************************
                                    (
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '-webkit-fill-available', overflow: 'auto' }}>
                                            {queReportData?.qtype != "12" && <div style={{ fontWeight: '600' }}
                                                dangerouslySetInnerHTML={{
                                                    __html: queReportData?.finalAnswer,
                                                }}
                                                className="table-container"
                                            />}

                                            {(queReportData?.qtype == "12" && queReportData?.perfact_metch?.length > 0) &&
                                                <DifferenceAnswer data={queReportData} />
                                            }
                                        </div>
                                    ) : (
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '-webkit-fill-available', overflow: 'auto' }}>
                                            {/* *****************************with m_equation********************************** */}
                                            {queReportData?.qtype != "12" && <div
                                                dangerouslySetInnerHTML={{
                                                    __html: queReportData?.finalAnswer,
                                                }}
                                                style={{ width: "-webkit-fill-available" }}
                                                className="table-container"
                                            />}

                                            {/* match the following */}
                                            {(queReportData?.qtype == "12" && queReportData?.perfact_metch?.length > 0) &&
                                                <DifferenceAnswer data={queReportData} />
                                            }
                                        </div>

                                    )}
                            </div>
                        </div>
                    </div>
                    <Divider style={{ margin: '10px 0px' }} />
                    <div className="mb-6">
                        <p className="font-medium mb-2">On which mistake of report you want to make?</p>
                        <div className="flex flex-wrap gap-4">
                            {['Question', 'Answer', 'Other'].map((option) => (
                                <label key={option} className="flex items-center">
                                    <input
                                        type="radio"
                                        name="mistakeType"
                                        value={option}
                                        checked={mistakeType === option}
                                        onChange={(e) => setMistakeType(e.target.value)}
                                        className="mr-2"
                                        defaultValue={"Question"}
                                    />
                                    {option + ' ' + "Mistake?"}
                                </label>
                            ))}
                        </div>
                    </div>
                    <Divider style={{ margin: '10px 0px' }} />

                    <div className="mb-6">
                        <p className="font-medium mb-2">Upload Image of your Query</p>
                        <div className="flex items-center justify-center w-full h-32 px-4 transition bg-white border-2 border-gray-300 border-dashed rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none">
                            <div className="flex items-center space-x-2">
                                {image ?
                                    <div style={{ position: 'relative' }}>
                                        <img
                                            src={image}
                                            alt="logo"
                                            className="max-h-28  rounded-md border-2 border-gray-300"
                                        />
                                        <button
                                            onClick={handleImageRemove}
                                            className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 bg-white border border-gray-300 text-gray-600 rounded-full p-1 hover:bg-gray-200"
                                            style={{ width: '24px', height: '24px', lineHeight: '0' }}
                                        >
                                            &#10005; {/* This is the "x" symbol for close */}
                                        </button>
                                    </div>
                                    :
                                    <>
                                        <Upload className="w-6 h-6 text-gray-600" onClick={handleImageUploadClick} />
                                        <span className="font-medium text-gray-600">"Upload Query Image" </span>
                                    </>}
                            </div>
                        </div>
                        <input
                            type="file"
                            name="file_upload"
                            ref={fileInputRef}
                            className="hidden"
                            onChange={handleImageUpload}
                            accept="image/*"
                        />
                    </div>

                    <div className="mb-6">
                        <label htmlFor="description" className="block font-medium mb-2">
                            Description
                        </label>
                        <textarea
                            id="description"
                            rows={3}
                            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
                            placeholder="Youth Education"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        ></textarea>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default QuestionReportModel